import { CalendarClock } from "lucide-react";
import { BlockCategory, registerBlock } from "../../lib/register-block";
import { EstimatedDeliveryDateEditorRenderer } from "./editor";
import { EstimatedDeliveryDateEmailRenderer } from "./email";
import { EstimatedDeliveryDateEmailPanelRenderer } from "./email-panel";
import type { EstimatedDeliveryDateBlockProps } from "./types";
import { EstimatedDeliveryDateWebRenderer } from "./web";
import { EstimatedDeliveryDateWebEditor } from "./web-editor";


export default registerBlock<EstimatedDeliveryDateBlockProps>({
  type: "estimated-delivery-date",
  name: "editorBlocksLibrary.blocks.estimated-delivery-date.title",
  description: "editorBlocksLibrary.blocks.estimated-delivery-date.description",
  Icon: CalendarClock,
  category: BlockCategory.TRACKING,
  hasDynamicContent: true,
  components: {
    email: {
      component: EstimatedDeliveryDateEmailRenderer,
      editor: {
        component: EstimatedDeliveryDateEditorRenderer,
      },
      configPanel: {
        features: {
          delete: true,
        },
        component: EstimatedDeliveryDateEmailPanelRenderer,
      },
      compatibility: {
        rowBlock: false,
      },
    },
    web: {
      component: EstimatedDeliveryDateWebRenderer,
      editor: {
        component: EstimatedDeliveryDateWebEditor,
      },
      configPanel: {
        features: {
          delete: true,
        },
      },
      compatibility: {
        rowBlock: false,
      },
    },
  },
});

export type {
  EstimatedDeliveryDateBlock,
  EstimatedDeliveryDateBlockProps,
} from "./types";
